export const ASSET = {
  path: '/common/employee-assets', options: '/options', issue: '/issue', actions: '/actions',
  history: '/history', query: 'q', revokeAccess: 'CONFIRM_ACCESS_REVOKED',
  slash: '/', empty: '', open: 'OPEN', all: 'ALL', historyView: 'HISTORY', due: 'DUE',
  serialized: 'SERIALIZED', quantity: 'QUANTITY', consumable: 'CONSUMABLE', service: 'SERVICE',
  itEquipment: 'IT_EQUIPMENT', tools: 'TOOLS', access: 'ACCESS',
  serviceOwner: 'SERVICE_OWNER', assetCustodian: 'ASSET_CUSTODIAN',
  returnAction: 'RETURN',
  zero: 0, one: 1, pageSize: 25, maxQuantity: 100, dayLength: 10, currencyLength: 3,
  invalid: 400, forbidden: 403, unauthorized: 401, conflict: 409, validationKey: 'ASSET_VALIDATION',
  employeeId: 'employeeId', view: 'view', page: 'page', size: 'size', ownerId: 'ownerId',
  actionPrefix: 'ASSET_ACTION_', statusPrefix: 'ASSET_STATUS_', kindPrefix: 'ASSET_KIND_', categoryPrefix: 'ASSET_CATEGORY_',
  modalSize: <'lg'>'lg', deniedKey: 'ASSET_DENIED', conflictKey: 'ASSET_CONFLICT',
  failureKey: 'ASSET_LOAD_FAILED', unknownKey: 'ASSET_RESULT_UNKNOWN', savedKey: 'ASSET_SAVED',
  monthly: 'MONTHLY', yearly: 'YEARLY', once: 'ONE_TIME', unknown: 'UNKNOWN',
  yes: 'YES', no: 'NO', byn: 'BYN', dash: '-', operationPrefix: 'asset-',
  randomRadix: 36, randomOffset: 2, dateSeparator: 'T'
};
export const ASSET_ISSUE_TYPES = [ASSET.itEquipment, ASSET.tools, ASSET.consumable, ASSET.service];



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/asset.constants.ts